import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type GridLayoutProps = {
  sections: Section[];
};
export type Section = {
  key: SectionKeys;
  content: React.ReactElement<any>;
};
export enum SectionKeys {
  CUSTOM = 'custom',
  DOCUMENTS = 'documents',
  BASIC = 'basic',
  ADDRESS = 'address',
  US_LEGAL = 'us-legal',
  BUSINESS_OWNERS = 'business-owners',
  FINANCIAL = 'financial',
  IDENTITY = 'identity',
  INVESTOR = 'investor',
}
const GridLayout = t0 => {
  const $ = _c(12);
  const {
    sections
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== sections) {
    const sortedSections = [...sections].sort(_temp);
    const specialWideSections = sortedSections.filter(_temp2);
    const topSections = sortedSections.filter(_temp3);
    t4 = "@container";
    t1 = "grid grid-cols-1 gap-3 @3xl:grid-cols-2";
    t2 = topSections.map((section_1, index) => {
      const topSectionsAreEven = topSections.length % 2 === 0;
      const isLastSection = index === topSections.length - 1;
      return <div key={section_1.key} className={cx("h-full", {
        "@3xl:col-span-2": !topSectionsAreEven && isLastSection
      })}>{section_1.content}</div>;
    });
    t3 = specialWideSections.map(_temp4);
    $[0] = sections;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t5 = <div className={t1}>{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default GridLayout;
function _temp(a, b) {
  const endSections = [SectionKeys.CUSTOM, SectionKeys.DOCUMENTS, SectionKeys.INVESTOR];
  const aIsEndSection = endSections.includes(a.key);
  const bIsEndSection = endSections.includes(b.key);
  if (aIsEndSection && !bIsEndSection) {
    return 1;
  }
  if (!aIsEndSection && bIsEndSection) {
    return -1;
  }
  return 0;
}
function _temp2(section) {
  return [SectionKeys.DOCUMENTS, SectionKeys.CUSTOM, SectionKeys.INVESTOR].includes(section.key);
}
function _temp3(section_0) {
  return section_0.key !== SectionKeys.DOCUMENTS && section_0.key !== SectionKeys.CUSTOM && section_0.key !== SectionKeys.INVESTOR;
}
function _temp4(section_2) {
  return <div key={section_2.key} className="h-full @3xl:col-span-2">{section_2.content}</div>;
}